import { DashboardsApi as DashboardsApiGen } from './gen/dashboard'
import { DefaultApi as AnalyticsApiGen } from './gen/analytics'
import { RestApiConfiguration } from './config'

export const DashboardsApi = new DashboardsApiGen(RestApiConfiguration)

export const AnalyticsApi = new AnalyticsApiGen(RestApiConfiguration)
